import styled from "@emotion/styled";
import { Box, MobileStepper, Theme } from "@mui/material";

export const StyledBox = styled(Box)(() => ({
  "& img": {
    maxWidth: "95%",
    borderRadius: "10px",
    margin: "8px" 
  },
}));

export const StyledMobileStepper = styled(MobileStepper)<{theme: Theme}>((props) => ({
  backgroundColor: "unset",
  justifyContent: "center",
  '& .MuiMobileStepper-dotActive':{
    backgroundColor: props.theme.palette.secondary.main,
  }
}));